export default __webpack_public_path__ + "static/Plantas-9523e66dc94c3bc9a846551de6382fe3.svg";